
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import { Options, Vue } from "vue-class-component"; //基本需要\
import * as echarts from "echarts";
import { ElMessage } from "element-plus";
import {
  dispatchGetNewReportList,
  dispatchGetReportDetail,
  dispatchGetSkinReport,
  dispatchUploadReportImage,
  dispatchDeleteReport,
  dispatchGetReportSmgReport,
  dispatchRecentTaskrecord,
  dispatchCreateReportByTask,
  dispatchClearCache,
} from "@/store/performance/actions";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  readNewReportList,
  readNewReport,
  readSkinReport,
  readNewSmgReport,
  readRecentTaskrecord,
} from "@/store/performance/getters"; //引入仓库接口
import { store } from "@/store"; //引入仓库
import { number } from "echarts/core";
// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class TestReportSkin extends Vue {
  get_is_super = false
  dialogFormVisible2 = false
  dialogFormVisible1 = false
  public localProject = Number(getLocalProject()); //得到本地的项目
  public resBase64: any[] = [];
  //报告名称
  public drawList = [
    { title: "FPS性能趋势", value: "avg_fps" },
    { title: "PSS性能趋势", value: "avg_pss" },
  ];
  public loading = false; //加载
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public edit = false;
  public dialogFormVisibleByTask = false;
  public risk_thead = [];
  public async mounted() {
    this.report_loading = true;
    const project = Number(this.$route.query.project);
    // this.formMail.title = (readNewReportList(store) as any[]).filter(
    //   (item: any) => item.id === this.report_id
    // )[0].report_name;
    dispatchRecentTaskrecord(store, { project: project, report_type: 43 }); //表格对应label
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 43,
    });

    if (this.$route.query.report_id) {
      this.report_id = Number(this.$route.query.report_id);
      this.formMail.title = (readNewReportList(store) as any[]).filter(
        (item: any) => item.id === this.report_id
      )[0].report_name;
    } else {
      this.report_id = this.nameList[0] ? this.nameList[0]?.id : 0;
    }
    await dispatchGetReportDetail(store, {
      project: project,
      id: this.report_id,
    });
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    if (this.report_id) {
      await dispatchGetReportSmgReport(store, {
        project: this.localProject,
        report_id: this.report_id,
      });
    }

    await this.addressee;

    await this.getSkinReport();
    for (let i in this.get_skin_data.risk_list) {
      this.risk_list.push({
        name: i,
        value: this.get_skin_data.risk_list[i],
      });
    }

    this.risk_thead = Object.keys(this.risk_list[0].value);
    this.draw_scene = this.get_skin_data.all_echart_data.map((v) => v.scene)[0];
    this.resBase64 = [];
    this.drawList.forEach((v) => {
      this.$nextTick(() => {
        this.drawFps(v.value);
      });
    });
    this.report_loading = false;
    // await this.get_skin_data.all_echart_data.forEach((v: any, index: any) => {
    //   this.drawFps(v.scene, index);
    //   this.drawPSS(v.scene, index);
    // });

    // if (this.$route.query.report_id) {
    //   if (this.$route.query.project) {
    //     const project = Number(this.$route.query.project);
    //     await dispatchGetNewReportList(store, { project: this.localProject });
    //      await dispatchGetPerfReport(store, {
    //       project: project,
    //       report_id: Number(this.$route.query.report_id),
    //     });
    //   }
    // } else {
    //   await dispatchGetNewReportList(store, { project: this.localProject });
    //   (this.name_search as any) = readNewReportList(store)[0].id;
    //   this.$router.push({
    //     query: { ...this.$route.query, report_id: this.name_search },
    //   });
    //   this.formMail.title = (readNewReportList(store) as any[]).filter(
    //     (item: any) => item.id === this.name_search
    //   )[0].report_name;
    // }
  }
  public report_loading = false;
  public draw_scene = "";
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  //报告名称
  public testColor(data, item) {
    if (data.indexOf("↑") != -1) {
      if (item == "性能指标*FPS") {
        return "#00b050";
      } else {
        return "red";
      }
    } else {
      if (item == "性能指标*FPS") {
        return "red";
      } else {
        return "#00b050";
      }
    }
  }
  public compore_num(param: string, new_value: number, levle: any, model: any) {
    let level_type = "level_" + levle;
    let model_type = "";
    let color = "";
    if (model == 0) {
      model_type = "Android";
    } else if (model === 1) {
      model_type = "iOS";
    } else if (model === 2) {
      model_type = "PC";
    }
    if (this.get_skin_data.rule_settings.increase_good.includes(param)) {
      if (
        this.get_skin_data.rule_settings.tdr_risk_rule[model_type][level_type][
          param
        ]
      ) {
        if (
          new_value <
          this.get_skin_data.rule_settings.tdr_risk_rule[model_type][
            level_type
          ][param]
        ) {
          color = "red";
        } else {
          color = "";
        }
      } else {
        color = "";
      }
    } else {
      if (
        this.get_skin_data.rule_settings.tdr_risk_rule[model_type][level_type][
          param
        ]
      ) {
        if (
          new_value >
          this.get_skin_data.rule_settings.tdr_risk_rule[model_type][
            level_type
          ][param]
        ) {
          color = "red";
        } else {
          color = "";
        }
      } else {
        color = "";
      }
    }
    return color;
  }
  public getNum(item, item1, type) {
    item = Number(item);
    item1 = Number(item1);
    let num = "";
    let color = "";
    if (item > item1) {
      num = "(" + Math.abs(item - item1).toFixed(1) + "↑)";
      if (type) {
        if (type === "avg_fps") {
          if (Math.abs(item - item1) > 2) {
            color = "#00b050";
          }
        }
        if (type === "var_fps") {
          if (Math.abs(item - item1) > 10) {
            color = "red";
          }
        }
        if (type === "lag_pcnt") {
          if (Math.abs(item - item1) > 50) {
            color = "red";
          }
        }
        if (type === "max_pss") {
          if (Math.abs(item - item1) > 50) {
            color = "red";
          }
        }
        //   if(type==="lag_pcnt"){
        //      if(Math.abs(item-item1)>50){
        //     color='red'
        //   }
        //   if(type==="cpu_lt_60_pcnt"){
        //      if(Math.abs(item-item1)>5){
        //     color='red'
        //   }
        //   }
        //  }
      }
    }
    if (item === item1) {
      num = "(--)";
    }
    if (item < item1) {
      num = "(" + Math.abs(item - item1).toFixed(1) + "↓)";
      if (type) {
        if (type === "avg_fps") {
          if (Math.abs(item - item1) > 2) {
            color = "#red";
          }
        }
        if (type === "var_fps") {
          if (Math.abs(item - item1) > 10) {
            color = "00b050";
          }
        }
        if (type === "lag_pcnt") {
          if (Math.abs(item - item1) > 50) {
            color = "00b050";
          }
        }
        if (type === "max_pss") {
          if (Math.abs(item - item1) > 50) {
            color = "00b050";
          }
        }
      }
    }
    return [num, color];
  }
  public report_id = 0;
  // 核心数据类型
  public get_skin_data: any = {
    risk_list: {},
    model_list: [],
    all_echart_data: [],
    new_version: "",
    old_version: "",
    project: {
      icon: "",
      project_name: "",
    },
    base: {
      creator: "",
      date: "",
      skin_num: 0,
      version: "",
    },
    device_list: [],
    device_type: "安卓",
    rule_settings: {
      increase_good: [],
      tdr_risk_rule: {},
    },
  };
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readNewReportList(store);
    return name_list;
  }
  public riskLv = "";
  public get_color(item: any, value: any) {
    if (
      (this.get_skin_data.rule_settings.increase_good as any).indexOf(item) !=
        -1 &&
      this.get_skin_data.rule_settings.tdr_risk_rule[item]
    ) {
      if (
        value < Number(this.get_skin_data.rule_settings.tdr_risk_rule[item])
      ) {
        return "red";
      }
    } else if (
      (this.get_skin_data.rule_settings.increase_good as any).indexOf(item) ==
        -1 &&
      this.get_skin_data.rule_settings.tdr_risk_rule[item]
    ) {
      if (
        value > Number(this.get_skin_data.rule_settings.tdr_risk_rule[item])
      ) {
        return "red";
      } else {
        return "#212529";
      }
    }
  }
  // 报告名称切换时
  public async change_name_search() {
    this.report_loading = true;
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 43,
    });
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].report_name;
    await dispatchGetReportSmgReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.getSkinReport();
    this.risk_list = [];
    for (let i in this.get_skin_data.risk_list) {
      this.risk_list.push({
        name: i,
        value: this.get_skin_data.risk_list[i],
      });
    }

    this.risk_thead = Object.keys(this.risk_list[0].value);
    this.draw_scene = this.get_skin_data.all_echart_data.map((v) => v.scene)[0];
    this.resBase64 = [];
    this.drawList.forEach((v) => {
      this.$nextTick(() => {
        this.drawFps(v.value);
      });
    });
    this.report_loading = false;
  }
  // 发送报告
  public async save_report(is_auto?: boolean) {
    let b = (this as any).$message({
      //Message 消息提示
      message: "报告发送中,请耐心等待....",
      showClose: true,
      duration: 0,
    });
    let upload_data: any;
    this.draw_scene = this.get_skin_data.all_echart_data.map((v) => v.scene)[0];
    this.resBase64 = [];
    const drawFpsPromises = this.drawList.map(async (v) => {
      await this.$nextTick();
      await this.drawFps(v.value);
    });

    // 等待所有 drawFps 完成
    await Promise.all(drawFpsPromises);
    if (typeof is_auto === "boolean") {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.report_id),
        file_list: this.resBase64,
        is_auto: is_auto,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        report_type: 43,
        send: this.formMail.Sender,
      };
    } else {
      upload_data = {
        // project: Number(this.$route.query.project),
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.report_id),
        file_list: this.resBase64,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        report_type: 43,
        send: this.formMail.Sender,
      };
    }

    await dispatchUploadReportImage(store, upload_data);
    b.close();
    // ElMessage.success({
    //   message: "报告发送成功",
    //   showClose: true,
    //   type: "success",
    // });
    this.edit = false;
  }
  // 解析邮件收件人
  public get addressee() {
    let addressee = JSON.parse(readNewReport(store).settings).report_settings
      .notify.email.receiver_str;
    this.formMail.addressee = addressee;

    return addressee;
  }
  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称
  public generateReportsManuallyByTask() {
    this.dialogFormVisibleByTask = true;
    this.generateReportVersion.old_Edition = [];
    this.generateReportVersion.Edition = [];
    this.report_name_placeholder = "【GR自动化性能】项目名-new";
  }
  public canBeNumber(value) {
    const num = Number(value);
    return Number.isFinite(num);
  }
  public getColor(param, newValue, oldValue) {
    const list = [
      "avg_cpu",
      "gpu_usage",
      "DrawCall_change",
      "Primitives_change",
    ];
    let color = "";
    if (param == "avg_fps") {
      if (this.canBeNumber(newValue) && this.canBeNumber(oldValue)) {
        if (Number(oldValue) > Number(newValue)) {
          if (Number(oldValue) - Number(newValue) > 5) {
            color = "red";
          } else {
            color = "";
          }
        } else if (oldValue == newValue) {
          color = "";
        } else {
          color = "#00b050";
        }
      } else {
        color = "";
      }
    }
    if (list.includes(param)) {
      if (this.canBeNumber(newValue) && this.canBeNumber(oldValue)) {
        if (Number(newValue) > Number(oldValue)) {
          if (param == "avg_cpu") {
            if (Number(newValue) - Number(oldValue) > 10) {
              color = "red";
            } else {
              color = "";
            }
          }
          if (param == "gpu_usage") {
            if (Number(newValue) - Number(oldValue) > 10) {
              color = "red";
            } else {
              color = "";
            }
          }
          if (param == "DrawCall_change") {
            if (Number(newValue) - Number(oldValue) > 100) {
              color = "red";
            } else {
              color = "";
            }
          }
          if (param == "Primitives_change") {
            if (Number(newValue) - Number(oldValue) > 100000) {
              color = "red";
            } else {
              color = "";
            }
          }
        }
      } else {
        color = "";
      }
    }

    if (param == "max_pss") {
      if (this.canBeNumber(newValue) && this.canBeNumber(oldValue)) {
        if (Number(newValue) > Number(oldValue)) {
          if (Number(newValue) - Number(oldValue) > 150) {
            color = "red";
          } else {
            color = "";
          }
        } else if (oldValue == newValue) {
          color = "";
        } else {
          color = "#00b050";
        }
      } else {
        color = "";
      }
    }
    if (param == "DrawCall") {
      if (this.canBeNumber(newValue)) {
        if (Number(newValue) > 500) {
          color = "red";
        }
      }
    }
    if (param == "Primitives") {
      if (this.canBeNumber(newValue)) {
        if (Number(newValue) > 700000) {
          color = "red";
        }
      }
    }

    return color;
  }
  public generateReportVersion = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: "",
    newEdition: "",
    scenetion: [],
    reportType: "",
    Edition: [],
    old_Edition: [],
  };
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }
  public async clear() {
    this.report_loading = true;
    await dispatchClearCache(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await dispatchGetReportSmgReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.addressee;
    await this.getSkinReport();
    for (let i in this.get_skin_data.risk_list) {
      this.risk_list.push({
        name: i,
        value: this.get_skin_data.risk_list[i],
      });
    }

    this.risk_thead = Object.keys(this.risk_list[0].value);
    this.draw_scene = this.get_skin_data.all_echart_data.map((v) => v.scene)[0];
    this.resBase64 = [];
    this.drawList.forEach((v) => {
      this.$nextTick(() => {
        this.drawFps(v.value);
      });
    });
    this.report_loading = false;
  }
  public test_type = [
    { name: "关卡测试", value: 42 },
    { name: "UI测试", value: 43 },
    { name: "UI&关卡测试", value: 44 },
  ];
  public async generateReportByTask() {
    this.report_loading = true;
    this.dialogFormVisibleByTask = false;
    await dispatchCreateReportByTask(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      task_record_id: this.generateReportVersion.Edition.join("、"),
      old_record_id: this.generateReportVersion.old_Edition.join("、"),
      report_type: this.generateReportVersion.reportType as any,
    });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 43,
    });
    this.report_id = this.nameList[0] ? this.nameList[0]?.id : 0;

    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: this.report_id,
    });
    await dispatchGetReportSmgReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.addressee;
    await this.getSkinReport();
    for (let i in this.get_skin_data.risk_list) {
      this.risk_list.push({
        name: i,
        value: this.get_skin_data.risk_list[i],
      });
    }

    this.risk_thead = Object.keys(this.risk_list[0].value);
    this.draw_scene = this.get_skin_data.all_echart_data.map((v) => v.scene)[0];
    this.resBase64 = [];
    this.drawList.forEach((v) => {
      this.$nextTick(() => {
        this.drawFps(v.value);
      });
    });
    this.report_loading = false;
  }
  // 获取报告数据
  public getSkinReport() {
    this.get_skin_data = readNewSmgReport(store);
    this.get_skin_data.base.date = dateConversion(
      readNewSmgReport(store).base.date
    );
    let riskLvList = [];
    let riskLvList1: any = [];
    for (let i in this.get_skin_data.model_list) {
      for (let k in this.get_skin_data.model_list[i].data) {
        riskLvList.push(this.get_skin_data.model_list[i].data[k]);
      }
    }
    riskLvList.forEach((v: any) => {
      v.forEach(function (k: any) {
        riskLvList1.push(k.var_fps);
      });
    });
    let list = [];
    for (let i in this.get_skin_data.risk_list) {
      for (let k in this.get_skin_data.risk_list[i]) {
        list.push(this.get_skin_data.risk_list[i][k]);
      }
    }

    let risk = list.every((v) => v.length == 0);

    if (this.localProject == 59) {
      this.riskLv = this.get_skin_data.risk
    } else {
      this.riskLv = risk === false ? "高风险" : "低风险";
    }
  }
  public sendOut() {
    this.edit = !this.edit;
  }
  public drawFps(i) {
    let list = this.get_skin_data.all_echart_data.filter((v, index) => {
      return v.scene === this.draw_scene;
    })[0].echart_data;

    let series = [];
    list.device_names.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: list.series[index].map((k) => k[i]),
      });
    });

    let performance_line: any = document.getElementById(this.draw_scene + i);
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",

        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: list.x_axis_format,
      },

      series: series,
    });
    let res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};

    res.file_base64 = res_base64;
    res.filename =
      "ui_test_smg_report" +
      this.get_skin_data.all_echart_data
        .map((v) => v.scene)
        .findIndex((item) => item == this.draw_scene) +
      "-" +
      i +
      ".png";

    this.resBase64.push(res);

    return contrastChart;
  }
  public drawPSS(id, i) {
    let list = this.get_skin_data.all_echart_data.filter((v, index) => {
      return v.scene === id;
    })[0].echart_data;

    let series = [];
    list.device_names.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: list.series[index].map((k) => k.avg_pss),
      });
    });

    let performance_line: any = document.getElementById(id + "avg_pss");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",

        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: list.x_axis_format,
      },

      series: series,
    });
    let res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};

    res.file_base64 = res_base64;
    res.filename = "ui_test_report" + i + "avg_pss" + ".png";

    this.resBase64.push(res);
  }
  public risk_list = [];
  // 点击删除
  public async handleDelete() {
    this.loading = true;

    await dispatchDeleteReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
      page: 1,
      size: 1,
      report_name: "",
      new_version: "",
      old_version: "",
      risk: "",
      creator: "",
    });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 43,
    });
    this.report_id = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });

    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.report_id),
    });
    //调用获取性能报告接口
    await dispatchGetReportSmgReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });

    //启用生成报告的接口

    await this.getSkinReport();
    for (let i in this.get_skin_data.risk_list) {
      this.risk_list.push({
        name: i,
        value: this.get_skin_data.risk_list[i],
      });
    }

    this.risk_thead = Object.keys(this.risk_list[0].value);
    this.draw_scene = this.get_skin_data.all_echart_data.map((v) => v.scene)[0];
    this.resBase64 = [];
    this.drawList.forEach((v) => {
      this.$nextTick(() => {
        this.drawFps(v.value);
      });
    });
    // await this.get_skin_data.all_echart_data.forEach((v: any, index: any) => {
    //   this.drawFps(v.scene, index);
    //   this.drawPSS(v.scene, index);
    // });

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }

    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.save_report();
    }

    // await this.addressee; //解析邮件收件人

    this.loading = false;
  }
  public scene_change() {
    this.drawList.forEach((v) => {
      this.$nextTick(() => {
        this.drawFps(v.value);
      });
    });
  }
  public get get_pipeline() {
    if (this.get_skin_data.device_type === "安卓、iOS") {
      return "【Android】Trunk性能包构建，【iOS】Trunk性能包构建";
    } else if (this.get_skin_data.device_type === "安卓") {
      return "【Android】Trunk性能包构建";
    } else {
      return "【iOS】Trunk性能包构建";
    }
  }
  public shouldDisplayHeroName(item, index) {
    if (index === 0) return true; // 第一个英雄名称始终显示
    return item[index].hero_name !== item[index - 1].hero_name; // 对比当前行的英雄名称
  }
  public getRowspan(item, index) {
    let count = 1;
    for (let i = index + 1; i < item.length; i++) {
      if (item[i].hero_name === item[index].hero_name) {
        count++;
      } else {
        break;
      }
    }
    return count;
  }
  gameList(model) {
    let list = [
      //   "英雄",
      "UI场景",
      "UI名",
      "帧率均值",
      "Jank",
      "≥25帧占比",
      "≥18帧占比",
      "平均CPU",
      "PSS峰值",
      // "SMG-FPS",
      // "SMG-FrameTime",
      "gpu_usage",
      "DrawCall",
      "Primitives",
      "GPU_General_Clocks",
      "MAX_GPU_General_Clocks",
      "perfdog链接",
    ];

    if (model.model_type == 1) {
      list = [
        "UI场景",
        "UI名",
        "帧率均值",
        "Jank",
        "≥25帧占比",
        "≥18帧占比",
        "平均CPU",
        "PSS峰值",
        // 'Device',
        // 'Render',
        // 'Tiler',
        // "SMG-FPS",
        // "SMG-FrameTime",
        "DrawCall",
        "Primitives",
        "perfdog链接",
      ]
    } else if (this.localProject == 59) {
      list = [
        //   "英雄",
        "UI场景",
        "UI名",
        "帧率均值",
        "Jank",
        "≥25帧占比",
        "≥18帧占比",
        "平均CPU",
        "PSS峰值",
        // "SMG-FPS",
        // "SMG-FrameTime",
        "gpu_usage",
        "DrawCall",
        "Primitives",
        "perfdog链接",
      ]
    }

    return list;
  }
}
